import { CertificateTemplate } from '../types';

export const verticalModernoTemplate: CertificateTemplate = {
  id: 'vertical-moderno-01',
  name: 'Vertical Moderno',
  description: 'Certificado vertical com design moderno e minimalista',
  category: 'curso',
  orientation: 'vertical',
  canvasWidth: 595,
  canvasHeight: 842,
  previewBackgroundColor: '#f8f9fa',
  fabricJsonFront: JSON.stringify({
    version: "6.7.1",
    width: 595,
    height: 842,
    objects: [
      // Fundo branco
      {
        type: "Rect",
        version: "6.7.1",
        originX: "left",
        originY: "top",
        left: 0,
        top: 0,
        width: 595,
        height: 842,
        fill: "#ffffff",
        stroke: null,
        selectable: true,
        evented: true
      },
      // Barra lateral esquerda decorativa
      {
        type: "Rect",
        version: "6.7.1",
        originX: "left",
        originY: "top",
        left: 0,
        top: 0,
        width: 10,
        height: 842,
        fill: "#2563eb",
        stroke: null,
        selectable: true,
        evented: true
      },
      // Círculo decorativo superior
      {
        type: "Circle",
        version: "6.7.1",
        originX: "center",
        originY: "center",
        left: 297.5,
        top: 100,
        radius: 45,
        fill: "transparent",
        stroke: "#2563eb",
        strokeWidth: 3,
        selectable: true,
        evented: true
      },
      // Ícone de medalha
      {
        type: "Polygon",
        version: "6.7.1",
        originX: "center",
        originY: "center",
        left: 297.5,
        top: 100,
        points: [
          {x: 0, y: -15},
          {x: 4.5, y: -6.2},
          {x: 14.6, y: -4.7},
          {x: 7.3, y: 2.4},
          {x: 9, y: 12.4},
          {x: 0, y: 7.7},
          {x: -9, y: 12.4},
          {x: -7.3, y: 2.4},
          {x: -14.6, y: -4.7},
          {x: -4.5, y: -6.2}
        ],
        fill: "#fbbf24",
        stroke: "#f59e0b",
        strokeWidth: 1,
        scaleX: 2,
        scaleY: 2,
        selectable: true,
        evented: true
      },
      // Título CERTIFICADO
      {
        type: "Textbox",
        version: "6.7.1",
        originX: "center",
        originY: "center",
        left: 297.5,
        top: 190,
        width: 400,
        height: 35,
        fill: "#1e293b",
        fontSize: 36,
        fontWeight: "bold",
        fontFamily: "Montserrat",
        text: "CERTIFICADO",
        textAlign: "center",
        charSpacing: 80,
        selectable: true,
        evented: true
      },
      // Subtítulo
      {
        type: "Textbox",
        version: "6.7.1",
        originX: "center",
        originY: "center",
        left: 297.5,
        top: 240,
        width: 350,
        height: 20,
        fill: "#64748b",
        fontSize: 18,
        fontFamily: "Open Sans",
        text: "DE CONCLUSÃO",
        textAlign: "center",
        charSpacing: 40,
        selectable: true,
        evented: true
      },
      // Linha divisória
      {
        type: "Line",
        version: "6.7.1",
        originX: "center",
        originY: "center",
        left: 297.5,
        top: 290,
        x1: -80,
        x2: 80,
        y1: 0,
        y2: 0,
        stroke: "#e2e8f0",
        strokeWidth: 2,
        selectable: true,
        evented: true
      },
      // Texto "Certificamos que"
      {
        type: "Textbox",
        version: "6.7.1",
        originX: "center",
        originY: "center",
        left: 297.5,
        top: 330,
        width: 400,
        height: 20,
        fill: "#475569",
        fontSize: 16,
        fontFamily: "Open Sans",
        text: "Certificamos que",
        textAlign: "center",
        selectable: true,
        evented: true
      },
      // Nome do aluno
      {
        type: "Textbox",
        version: "6.7.1",
        originX: "center",
        originY: "center",
        left: 297.5,
        top: 380,
        width: 450,
        height: 30,
        fill: "#1e293b",
        fontSize: 28,
        fontWeight: "bold",
        fontFamily: "Montserrat",
        text: "{{aluno_nome}}",
        textAlign: "center",
        selectable: true,
        evented: true
      },
      // CPF
      {
        type: "Textbox",
        version: "6.7.1",
        originX: "center",
        originY: "center",
        left: 297.5,
        top: 430,
        width: 400,
        height: 18,
        fill: "#64748b",
        fontSize: 14,
        fontFamily: "Open Sans",
        text: "CPF: {{aluno_cpf}}",
        textAlign: "center",
        selectable: true,
        evented: true
      },
      // Texto do curso
      {
        type: "Textbox",
        version: "6.7.1",
        originX: "center",
        originY: "center",
        left: 297.5,
        top: 500,
        width: 450,
        height: 80,
        fill: "#475569",
        fontSize: 15,
        fontFamily: "Open Sans",
        text: "Concluiu com êxito o curso de {{curso_nome}}, realizado pela {{inscricao_empresa}}, com carga horária de {{turma_carga_horaria}} horas.",
        textAlign: "center",
        lineHeight: 1.5,
        selectable: true,
        evented: true
      },
      // Data
      {
        type: "Textbox",
        version: "6.7.1",
        originX: "center",
        originY: "center",
        left: 297.5,
        top: 600,
        width: 400,
        height: 18,
        fill: "#64748b",
        fontSize: 14,
        fontFamily: "Open Sans",
        fontStyle: "italic",
        text: "São Paulo, {{turma_data_fim_extenso}}",
        textAlign: "center",
        selectable: true,
        evented: true
      },
      // Linha assinatura
      {
        type: "Line",
        version: "6.7.1",
        originX: "center",
        originY: "center",
        left: 297.5,
        top: 700,
        x1: -90,
        x2: 90,
        y1: 0,
        y2: 0,
        stroke: "#cbd5e1",
        strokeWidth: 1,
        selectable: true,
        evented: true
      },
      // Nome instrutor
      {
        type: "Textbox",
        version: "6.7.1",
        originX: "center",
        originY: "center",
        left: 297.5,
        top: 720,
        width: 280,
        height: 16,
        fill: "#64748b",
        fontSize: 14,
        fontFamily: "Open Sans",
        text: "{{instrutor_nome_1}}",
        textAlign: "center",
        selectable: true,
        evented: true
      },
      // Cargo instrutor
      {
        type: "Textbox",
        version: "6.7.1",
        originX: "center",
        originY: "center",
        left: 297.5,
        top: 745,
        width: 280,
        height: 16,
        fill: "#94a3b8",
        fontSize: 13,
        fontFamily: "Open Sans",
        text: "Instrutor Responsável",
        textAlign: "center",
        selectable: true,
        evented: true
      },
      // Código de validação
      {
        type: "Textbox",
        version: "6.7.1",
        originX: "center",
        originY: "center",
        left: 297.5,
        top: 800,
        width: 400,
        height: 12,
        fill: "#94a3b8",
        fontSize: 11,
        fontFamily: "monospace",
        text: "Código: {{certificado_codigo}}",
        textAlign: "center",
        selectable: true,
        evented: true
      }
    ]
  }),
  fabricJsonBack: undefined,
  defaultVariables: {
    aluno_nome: 'Nome do Aluno',
    aluno_cpf: '000.000.000-00',
    curso_nome: 'Nome do Curso',
    inscricao_empresa: 'Empresa Ltda',
    turma_carga_horaria: '40',
    turma_data_fim_extenso: '01 de Janeiro de 2025',
    instrutor_nome_1: 'Nome do Instrutor',
    certificado_codigo: 'CERT-2025-001'
  }
};